import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBackfillIndexnowV1Response } from './backfill-indexnow-v1-response';
import { backfillIndexnowV1ResponseSchema } from './backfill-indexnow-v1-response';

export async function backfillIndexnowV1Api(): Promise<
  IValidatedResponse<IBackfillIndexnowV1Response>
> {
  return postRequest<IBackfillIndexnowV1Response>({
    path: '/sys/indexnow/v1/backfill',
    schema: backfillIndexnowV1ResponseSchema,
  });
}
